import type { ElementType } from 'react'
import {
  ModuleIcon,
  NotificationBadge,
  StatusDot,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'

interface ModulePictogramProps {
  icon: ElementType<{ size?: number }>
  count: number
  moduleKey: string
  statusDotLabel?: string
}

const ModulePictogram = ({ icon: Icon, count, moduleKey, statusDotLabel }: ModulePictogramProps) => (
  <ModuleIcon>
    <Icon size={16} />
    <NotificationBadge data-testid={`module-badge-${moduleKey}`} hidden={count === 0}>
      {count > 99 ? '99+' : count}
    </NotificationBadge>
    <StatusDot data-testid={`module-dot-${moduleKey}`} hidden={!statusDotLabel || count > 0} title={statusDotLabel} />
  </ModuleIcon>
)

export default ModulePictogram
